<template>
  <span>
    <div v-if="loadingMap" class="overlay rightActive">
      <img class="loading-animation" src="../assets/squares.gif">
    </div>
    <div id="map" class="rightActive">
    </div>
  </span>
</template>

<script>
var GoogleMapsLoader = require('google-maps')
var InfoBubble = require('js-info-bubble')
var MarkerClusterer = require('marker-clusterer-plus')
var _ = require('lodash')
import { mapActions } from 'vuex'
GoogleMapsLoader.KEY = 'AIzaSyAhR-P2aVjRaudax5LwOtldWQyBAfuJnCI'
var styles = [{'featureType': 'administrative', 'elementType': 'labels.text.fill', 'stylers': [{'color': '#444444'}]}, {'featureType': 'landscape', 'elementType': 'all', 'stylers': [{'color': '#f2f2f2'}]}, {'featureType': 'poi', 'elementType': 'all', 'stylers': [{'visibility': 'off'}]}, {'featureType': 'road', 'elementType': 'all', 'stylers': [{'saturation': -100}, {'lightness': 45}]}, {'featureType': 'road.highway', 'elementType': 'all', 'stylers': [{'visibility': 'simplified'}]}, {'featureType': 'road.arterial', 'elementType': 'labels.icon', 'stylers': [{'visibility': 'off'}]}, {'featureType': 'transit', 'elementType': 'all', 'stylers': [{'visibility': 'off'}]}, {'featureType': 'water', 'elementType': 'all', 'stylers': [{'color': '#D9E8F1'}, {'visibility': 'on'}]}, {'featureType': 'administrative', 'elementType': 'geometry.fill', 'stylers': [{ 'visibility': 'off' }]}, {'featureType': 'administrative', 'elementType': 'geometry', 'stylers': [{ 'visibility': 'off' }]}, { 'featureType': 'all', 'elementType': 'labels.text', 'stylers': [{ 'visibility': 'off' }] }]

export default {
  props: ['trip', 'loading'],
  data () {
    return {
      map: {},
      markers: [],
      initSeach: false,
      loadingMap: true
    }
  },
  watch: {
    trip (val) {
      this.buildMap(val)
    }
  },
  methods: {
    ...mapActions([
      'setCurrentDest'
    ]),
    markerIconPicker (trip, currentDest) {
      var activeGrayIcon = require('../assets/gray-lg-icon.png')
      var grayIcon = require('../assets/gray-icon.png')
      var blueIcon = require('../assets/blue-icon.png')
      var activeBlueIcon = require('../assets/blue-lg-icon.png')
      var mediumBlueIcon = require('../assets/medium-blue-icon.png')
      var activeMediumBlueIcon = require('../assets/medium-blue-lg-icon.png')
      if (!_.has(trip, 'acf.featured_trip')) { return }
      if (trip.types.indexOf('future-trips') !== -1) {
        if (currentDest || trip.acf.featured_trip) {
          return activeGrayIcon
        }
        return grayIcon
      } else if (trip.types.indexOf('faculty-led') !== -1) {
        if (currentDest || trip.acf.featured_trip) {
          return activeBlueIcon
        }
        return blueIcon
      } else {
        if (currentDest || trip.acf.featured_trip) {
          return activeMediumBlueIcon
        }
        return mediumBlueIcon
      }
    },
    colorPicker (trip, currentDest = false) {
      if (trip.types.indexOf('future-trips') !== -1) {
        return '#5C5C5C'
      } else if (trip.types.indexOf('faculty-led') !== -1) {
        return '#043969'
      } else {
        return '#003DA7'
      }
    },
    buildMap (trip) {
      var map = {}
      var markers = []
      var icon = this.markerIconPicker(trip)
      // Google Maps
      GoogleMapsLoader.load((google) => {
        this.map = new google.maps.Map(document.getElementById('map'), {
          center: {lat: 0, lng: 0},
          zoom: 2,
          // styles: styles,
          mapTypeControl: false
        })

        this.map.addListener('idle', () => {
          this.loadingMap = false
        })

        var destPathCoords = []
        var bounds = new google.maps.LatLngBounds()
        var viewBounds = new google.maps.LatLngBounds()
        var i
        for (i = 0; i < trip.acf.destinations.length; ++i) {
          var lat = Number(trip.acf.destinations[i].location.lat)
          var lng = Number(trip.acf.destinations[i].location.lng)
          var marker = new google.maps.Marker({
            position: {lat: lat, lng: lng},
            map: this.map,
            dest: trip.acf.destinations[i],
            icon: icon
          })
          destPathCoords.push({'lat': lat, 'lng': lng})
          var latlng = new google.maps.LatLng(lat, lng)
          bounds.extend(latlng)
          viewBounds.extend(latlng)

          marker.addListener('click', () => {
            console.log(marker.dest)
            this.setCurrentDest(marker.dest)
          })
          // this.markers.push(marker)
        }

        var destPath = new google.maps.Polyline({
          path: destPathCoords,
          geodesic: true,
          strokeColor: '#bdc7d1',
          strokeOpacity: 1.0,
          strokeWeight: 2
        })

        destPath.setMap(this.map)

        if (bounds) {
          var sw = bounds.getSouthWest()
          var ne = bounds.getNorthEast()

          var lat1 = sw.lat()
          var lng1 = sw.lng()
          var lat2 = ne.lat()
          var lng2 = ne.lng()

          var dx = (lng1 - lng2) / 2
          var dy = (lat1 - lat2) / 2
          var cx = (lng1 + lng2) / 2
          var cy = (lat1 + lat2) / 2

          // work around a bug in google maps...
          lng1 = cx + dx
          lng2 = cx - dx
          lat1 = cy + dy
          lat2 = cy - dy * 1.5

          sw = new google.maps.LatLng(lat1, lng1)
          ne = new google.maps.LatLng(lat2, lng2)
          bounds = new google.maps.LatLngBounds(sw, ne)

          // Don't zoom in too far on only one marker
          if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
            var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.03, bounds.getNorthEast().lng() + 0.03)
            var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.03, bounds.getNorthEast().lng() - 0.03)
            bounds.extend(extendPoint1)
            bounds.extend(extendPoint2)
          }
          this.map.fitBounds(bounds)
        }
      })
    }
  }
}

var GmapsCubicBezier = (lat1, long1, lat2, long2, lat3, long3, lat4, long4, resolution, map) => {
  var points = []
  for (var it = 0; it <= 1; it += resolution) {
    points.push(this.getBezier({x: lat1, y: long1}, {x: lat2, y: long2}, {x: lat3, y: long3}, {x: lat4, y: long4}, it))
  }
  for (var i = 0; i < points.length - 1; i++) {
    var Line = new google.maps.Polyline({
      path: [new google.maps.LatLng(points[i].x, points[i].y), new google.maps.LatLng(points[i + 1].x, points[i + 1].y)],
      geodesic: true,
      strokeOpacity: 1,
      strokeColor: '#bdc7d1'
    })
    Line.setMap(map)
  }
}
GmapsCubicBezier.prototype = {
  B1: (t) => { return t * t * t },
  B2: (t) => { return 3 * t * t * (1 - t) },
  B3: (t) => { return 3 * t * (1 - t) * (1 - t) },
  B4: (t) => { return (1 - t) * (1 - t) * (1 - t) },
  getBezier: (C1, C2, C3, C4, percent) => {
    var pos = {}
    pos.x = C1.x * this.B1(percent) + C2.x * this.B2(percent) + C3.x * this.B3(percent) + C4.x * this.B4(percent)
    pos.y = C1.y * this.B1(percent) + C2.y * this.B2(percent) + C3.y * this.B3(percent) + C4.y * this.B4(percent)
    return pos
  }
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
  #map,
  .overlay {
    height: calc(100% - 60px);
    /*height: 100%;*/
    width: 100%;
    position: absolute;
    background:#d9e8f1!important;
    transition: all .5s ease;
    top: 0;
    left: 0;
  }
  #map.rightActive,
  .overlay.rightActive {
    width: 65%;
    transition: all .5s ease;
  }
  .gmapPoly {
    color:#ccc!important;
  }

  @media (max-width : 769px) and (orientation: portrait) {
    #map.rightActive, 
    .overlay.rightActive {
      height: calc(55% - 60px);
      width:100%;
    }
  }
  @media (max-width : 769px) and (orientation: landscape) {
    #map,
    .overlay {
      height:calc(100% - 35px);
    }
  }
</style>
<style>
  .infoBox {
    text-align:center;
    color:#fff;
    font-size:1.125em;
  }
  .infoBox p {
    padding:.75em 5px 0;
    margin:0;
  }
  .infoBoxImg {
    background-size:cover;
    background-repeat:no-repeat;
    background-position:center;
    width:125px;
    height:70px;
    margin-bottom:0;
  }
  .overlay {
    background-color: #fff !important;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .overlay img {
    width: 90px;
  }
</style>



// WEBPACK FOOTER //
// TripMap.vue?ae256874